import { GLOBAL_VARS } from '~/config';

export default function () {
    const { GOOGLE_TAG_MANAGER_ID } = GLOBAL_VARS;
    if (
        process.browser &&
        window.google_tag_manager &&
        window.google_tag_manager[GOOGLE_TAG_MANAGER_ID] &&
        window.google_tag_manager[GOOGLE_TAG_MANAGER_ID].dataLayer &&
        window.google_tag_manager[GOOGLE_TAG_MANAGER_ID].dataLayer.reset
    ) {
        window.google_tag_manager[GOOGLE_TAG_MANAGER_ID].dataLayer.reset();
    }
}
